import { gql } from '@apollo/client';

export const NOTIFICATION_EVENT = gql`
  subscription NotificationEvent($uId: String!) {
    notificationEvent(uId: $uId) {
      error
      payload
      uId
    }
  }
`;

export type NotificationEventData = {
  notificationEvent: {
    error: string | null;
    payload: string | null;
    uId: string;
  };
};

export type NotificationEventVariables = {
  uId: string;
};

export const INCOMING_NOTIFICATION_PAYLOAD = 'Incoming Notification';
